import CryptoJS from 'crypto-js'

export default {
  install(Vue, { store }) {
    const keyAccountUser = (key) => {
      let account = store.state.account
      let user = store.state.user

      return account && user ? `LSa${account.id}u${user.id}_${key}` : null
    }

    Vue.prototype.encrypt = text => {
      const passphrase = '123';
      return CryptoJS.AES.encrypt(text, passphrase).toString();
    }

    Vue.prototype.decrypt = ciphertext => {
      const passphrase = '123';
      const bytes = CryptoJS.AES.decrypt(ciphertext, passphrase);
      const originalText = bytes.toString(CryptoJS.enc.Utf8);
      return originalText;
    }

    const set = (key, value, { minutes, withoutKey, session = false } = {}) => {
      let data = { value: value }
      key = withoutKey ? key : keyAccountUser(key)

      minutes = (minutes && Number.isInteger(minutes)) ? minutes : 60 * 24
      let date = new Date()
      date.setMinutes(date.getMinutes() + minutes)
      data.expire = date
      data.createdAt = new Date().toISOString()

      if (session)
        sessionStorage.setItem(key, JSON.stringify(data))
      else
        localStorage.setItem(key, JSON.stringify(data))
    }

    const get = (key, { withoutKey, session } = {}) => {
      key = withoutKey ? key : keyAccountUser(key)
      let data

      if (session)
        data = JSON.parse(sessionStorage.getItem(key))
      else
        data = JSON.parse(localStorage.getItem(key))

      if (data){
        if (data.expire && (new Date() > new Date(data.expire)))
          return null
        else
          return data.value

      } else {
        return null
      }
    }

    const remove = (key, { withoutKey, session } = {}) => {
      key = withoutKey ? key : keyAccountUser(key)

      if (session)
        sessionStorage.removeItem(key)
      else
        localStorage.removeItem(key)
    }

    const clearAccountUser = () => {
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('LS'))
          localStorage.removeItem(key)
      })
    }

    const clear = () => {
      Object.keys(localStorage).forEach(key => {
        if (key !== 'authHeaders')
          localStorage.removeItem(key)
      })
    }

    const setSession = (key, value, { minutes, withoutKey } = {}) => {
      set(key, value, { minutes, session: true, withoutKey })
    }

    const getSession = (key, { withoutKey } = {}) => {
      return get(key, { session: true, withoutKey })
    }

    const removeSession = (key, { withoutKey } = {}) => {
      remove(key, { session: true, withoutKey })
    }

    const methods = {
      clear: clear,
      clearAccountUser: clearAccountUser,
      get: get,
      remove: remove,
      set: set
    }

    const sessionMethods = {
      get: getSession,
      remove: removeSession,
      set: setSession,
    }

    Vue.ls = methods
    Vue.prototype.$ls = methods
    Vue.ss = sessionMethods
    Vue.prototype.$ss = sessionMethods

    let checkExpired = () => {
      Object.entries(localStorage).forEach(([key, value]) => {
        if (!key.startsWith('LS'))
          return

        let data
        try {
          data = JSON.parse(value)
          // eslint-disable-next-line no-empty
        } catch (e) { }

        if (data && data.expire && (new Date() > new Date(data.expire)))
          localStorage.removeItem(key)
      })
    }

    setInterval(checkExpired, 1000 * 10 * 60)
    checkExpired()
  }
}
